<template>
  <SimpleModal v-model="showSentModal" title="Quesito correttamente inviato" :buttons="['Ok']" size="sm">
    <div class="text-center">
    </div>
  </SimpleModal>
  <!--<div v-if="isLoading" class="loading-overlay">-->
  <div v-show="isLoading">
    <LoadingOverlay :show="isLoading" title="Caricamento quesiti" :message="loadingMessage" />
    <!--<div class="loading-box">

      <div class="spinner-container">
        <div class="dot"></div>
        <div class="dot" style="animation-delay: 0.2s"></div>
        <div class="dot" style="animation-delay: 0.4s"></div>
      </div>

      <h5 class="mt-3">Caricamento in corso</h5>
      <p class="text-muted">{{ loadingMessage }}</p> </div>-->

    
  </div>

  <!--<div v-if="isLoading" class="loading-overlay d-flex justify-content-center align-items-center">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Caricamento...</span>
      </div>
      <div class="mt-2 fw-bold">Caricamento in corso...</div>
    </div>
  </div>-->
  <div class="question-list p-4">
    <ToastDialog :title="toastTitle" :message="toastMessage" :error="toastError" />

    <!--<CommonFilters :allTopics="allTopics" :allLegislations="allLegislations" :allArticles="allArticles"
      :allRegions="allRegions" :allYears="allYears" v-model:selectedTopics="selectedTopics"
      v-model:selectedLegislation="selectedLegislation" v-model:selectedArticles="selectedArticles"
      :isGestore="isGestore" @update:selectedLegislation="onLegislationChange"
      @update:selectedTopics="val => selectedTopics = val" @update:selectedArticles="val => selectedArticles = val"
      @filter="applyFilter" />-->


    <div class="mb-3 d-flex justify-content-between align-items-center">
      <!-- Selettore elementi per pagina -->
      <div class="d-flex align-items-center">
        <label class="me-2 mb-0">Elementi per pagina:</label>
        <select class="form-select w-auto" v-model.number="pagination.perPage" @change="loadQuestions(1)">
          <option v-for="n in [10, 25, 50, 100]" :key="n" :value="n">{{ n }}</option>
        </select>
      </div>

      <!-- Filtri e Ordina per -->
      <div class="d-flex align-items-center ms-auto gap-3">

        <!-- FILTRI -->
        <div class="dropdown dropend" data-bs-display="static">
          <span class="d-flex align-items-center dropdown-toggle" role="button" id="filterDropdown"
            data-bs-toggle="dropdown" aria-expanded="false" style="cursor:pointer;">
            Filtri
            <svg class="icon icon-xs ms-1">
              <use href="/bootstrap-italia/dist/svg/sprites.svg#it-funnel"
                xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-funnel"></use>
            </svg>
          </span>

          <ul class="dropdown-menu dropdown-menu-end p-3" aria-labelledby="filterDropdown"
            style="min-width: 320px; max-height: 300px; overflow-y:auto;" data-bs-auto-close="outside">

            <!-- Stato Quesito -->
            <li>
              <h6 class="dropdown-header fw-bold">Filtra per stato quesito</h6>
              <!--<div v-for="stato in statiQuesito" :key="stato.value" class="form-check" @click.stop>-->
              <div v-for="stato in visibleStatiQuesito" :key="stato.value" class="form-check" @click.stop>
                <input type="checkbox" class="form-check-input radio-look" :id="stato.value" :value="stato.value"
                  v-model="selectedStates" @change="applyFilter({ stato: selectedStates })">
                <label class="form-check-label" :for="stato.value">{{ stato.label }}</label>
              </div>
            </li>

            <li>
              <hr class="dropdown-divider">
            </li>

            <!-- Articolo -->
            <li>
              <h6 class="dropdown-header fw-bold">Filtra per articolo</h6>
              <div v-for="art in articoli" :key="art.value" class="form-check" @click.stop>
                <input type="checkbox" class="form-check-input radio-look" :id="art.value" :value="art.value"
                  v-model="selectedArticles" @change="applyFilter({ articolo: selectedArticles })">
                <label class="form-check-label" :for="art.value" :title="art.fullLabel || art.label">{{ art.label
                }}</label>
              </div>
            </li>

          </ul>
        </div>

        <!-- ORDINA PER -->
        <div class="dropdown" data-bs-display="static">
          <span class="d-flex align-items-center dropdown-toggle" role="button" id="sortDropdown"
            data-bs-toggle="dropdown" aria-expanded="false" style="cursor:pointer;">
            Ordina per
            <svg class="icon icon-xs ms-1">
              <use href="/bootstrap-italia/dist/svg/sprites.svg#it-expand"
                xlink:href="/bootstrap-italia/dist/svg/sprites.svg#it-expand"></use>
            </svg>
          </span>

          <ul class="dropdown-menu dropdown-menu-end p-2" aria-labelledby="sortDropdown"
            style="min-width: 220px; max-height: 200px; overflow-y:auto;" data-bs-auto-close="outside">

            <li v-for="option in sortOptions" :key="option.label">
              <a href="#" class="dropdown-item"
                :class="{ active: sortField === option.field && sortDirection === option.direction }"
                @click.prevent="selectSort(option)">
                {{ option.label }}
              </a>
            </li>

          </ul>
        </div>

      </div>
    </div>


    <!--<template v-if="isGestore">
      <GestoreTable :questions="questions" :pagination="pagination" :sort-field="sortField"
        :sort-direction="sortDirection" :state-icons="stateIcons" @page-change="loadQuestions" @sort="handleSort"
        @open-detail="openQuestionDetail" @change-view="changeView" />
    </template>-->

    <!--<template v-else>-->
    <transition-group name="fade-transition" mode="out-in">
      <div v-if="!isLoading" class="question-table-wrapper">
        <AppaltanteTable :questions="questions" :pagination="pagination" :sort-field="sortField" :showSearch="false"
          :sort-direction="sortDirection" :state-icons="stateIcons" @page-change="loadQuestions" @sort="handleSort"
          @open-detail="openQuestionDetail" class="it-table-wrapper" />
      </div>
    </transition-group>
    <!--</template>-->



    <ModalView v-model="showDetailModal" :title="`Dettaglio Quesito #${selectedQuestion.id || ''}`" icon="search"
      size="modal-xl">
      <QuestionForm v-model="selectedQuestion" :readonly="true" class="rounded-form" />
    </ModalView>
  </div>
</template>

<script>
import ToastDialog from '../../../components/common/ToastDialog.vue';
import BreadcrumbElement from '../../../components/common/BreadcrumbElement.vue';
import CommonFilters from './partials/CommonFilters.vue';
import AppaltanteTable from './partials/AppaltanteTable.vue';
import toastable from '../../../mixins/toastable';
import ModalView from '../../../components/common/ModalView.vue';
import QuestionForm from './partials/QuestionForm.vue';
import LoadingModal from '../../partials/LoadingModal.vue';
import SimpleModal from '../../../components/common/SimpleModal.vue';
import { useEventEmitter } from '../../../services/eventBus.js';
import LoadingOverlay from '../../partials/LoadingOverlay.vue';


export default {
  name: 'QuestionsView',
  components: {
    ToastDialog,
    BreadcrumbElement,
    CommonFilters,
    AppaltanteTable,
    //GestoreTable,
    ModalView,
    QuestionForm,
    LoadingModal,
    SimpleModal,
    LoadingOverlay
  },
  mixins: [toastable],
  data() {
    return {
      selectedQuestion: {
        object: '',
        text: '',
        topics: []
      },
      showDetailModal: false,
      isGestore: false,
      questions: [],
      pagination: { currentPage: 1, perPage: 10, total: 0, lastPage: 1 },
      sortField: 'created_at',
      sortDirection: 'desc',
      allTopics: [],
      allLegislations: [],
      allArticles: [],
      selectedTopics: [],
      selectedLegislation: null,
      selectedArticles: [],
      toastTitle: '',
      toastMessage: '',
      toastError: false,
      stateIcons: {
        INVIATO: { icon: 'bi-plus-circle', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Nuovo' },
        ASSEGNATO: { icon: 'bi-person-check', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Assegnato' },
        RISPOSTA_IN_BOZZA: { icon: 'bi-pencil-square', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Risposta in bozza' },
        EVASO: { icon: 'bi-check-circle', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Evaso' },
        IN_SALA_ATTESA: { icon: 'bi-hourglass', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'In sala d’attesa' },
        IN_ESAMINA_UOC: { icon: 'bi-search', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Assegnato a UOC' },
        NON_ASSEVERATO: { icon: 'bi-shield-exclamation', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Non asseverato' },
        ASSEVERATO: { icon: 'bi-shield-check', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Asseverato' },
        NON_PUBBLICATO: { icon: 'bi-eye-slash', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Non pubblicato' },
        PUBBLICATO: { icon: 'bi-eye', activeColor: '#0d6efd', inactiveColor: 'gray', label: 'Pubblicato' }
      },
      filterId: '',
      filterObject: '',
      filterOrganization: '',
      filterText: '',
      filterRegion: [],
      filterYear: [],
      allYears: [],
      isLoading: true,
      isDownloading: false,
      selectedStato: '',
      selectedArticolo: '',
      loadingMessage: "Attendere...",
      statiQuesito: [
        { label: 'Quesito Inviato', value: 'INVIATO' },
        { label: 'Quesito Assegnato', value: 'ASSEGNATO' },
        { label: 'Risposta evasa', value: 'EVASO' },
        { label: 'Risposta asseverata', value: 'ASSEVERATO' },
        //{ label: 'Risposta non asseverata', value: 'NON_ASSEVERATO' },
        { label: 'Parere Pubblicato', value: 'PUBBLICATO' },
      ],
      articoliTest: [
        { label: 'Articolo 1', value: 'articolo1' },
        { label: 'Articolo 2', value: 'articolo2' },
        { label: 'Articolo 3', value: 'articolo3' },
      ],
      articoli: [],
      sortOptions: [
        { label: 'Ordine crescente - codice identificativo', field: 'id', direction: 'asc' },
        { label: 'Ordine decrescente - codice identificativo', field: 'id', direction: 'desc' },
        { label: 'Ordine crescente - Data', field: 'created_at', direction: 'asc' },
        { label: 'Ordine decrescente - Data', field: 'created_at', direction: 'desc' },
      ],
      selectedStates: [],
      showSentModal: false,
    };
  },
  computed: {
    visibleStatiQuesito() {
      return this.statiQuesito.filter(stato =>
        ['INVIATO', 'ASSEGNATO', 'EVASO'].includes(stato.value)
      );
    },
  },
  methods: {
    formatArticleTitle(title) {
      if (!title) return '';

      // Caso "Art. <numero> ..."
      const artDotMatch = title.match(/^Art\.\s*(\d+)/i);
      if (artDotMatch) {
        return `Art.${artDotMatch[1]}`;
      }

      // Caso "Articolo <numero> ..."
      const articoloMatch = title.match(/^Articolo\s+(\d+)/i);
      if (articoloMatch) {
        return `Articolo ${articoloMatch[1]}`;
      }

      // Altrimenti titolo completo
      return title;
    },
    changeView(viewName, id) {
      console.log('Evento ricevuto:', viewName, id);
      this.$emit('change-view', viewName, id);
    },

    openQuestionDetail(item) {
      this.selectedQuestion = JSON.parse(JSON.stringify(item));
      this.showDetailModal = true;
    },
    async loadQuestions(page = 1) {
      this.isLoading = true;

      try {
        const params = {
          per_page: this.pagination.perPage,
          page,
          sortField: this.sortField,
          sortDirection: this.sortDirection,
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id: this.selectedLegislation || '',
          id: this.filterId || '',
          object: this.filterObject || '',
          organization: this.filterOrganization || '',
          text: this.filterText || '',
          region: Array.isArray(this.filterRegion) ? this.filterRegion.join(',') : '',
          year: Array.isArray(this.filterYear) ? this.filterYear.join(',') : '',
          state: this.selectedStates.join(','),
        };

        const token = localStorage.getItem('token');

        const url = new URL(`${this.$root.config.VITE_APP_BACKOFFICE_URL}/questions`);
        Object.entries(params).forEach(([key, val]) => {
          url.searchParams.append(key, val);
        });

        const response = await fetch(url.toString(), {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
          },
          //credentials: 'include'
        });

        const json = await response.json();

        if (!response.ok) {
          console.error("Errore fetch", json);
          return;
        }
        const allArticlesRemote = Object.values(this.$root.contents?.articles || {});

        this.questions = json.data.map(q => {
          if (q.articles?.length) {
            q.articles = q.articles.map(a => {
              const remote = allArticlesRemote.find(r => r.id === a.id);
              const title = remote?.versions?.length
                ? remote.versions[remote.versions.length - 1].title
                : null;
              return { ...a, title };
            });
          }
          return q;
        });
        this.pagination = {
          currentPage: json.current_page,
          perPage: json.per_page,
          total: json.total,
          lastPage: json.last_page
        };

        /**if (this.articoli.length === 0 && json.allArticles) {
          this.articoli = json.allArticles.map(a => ({
            value: a.id,
            label: `Articolo ${a.id}`
          }));
        }*/

        if (this.articoli.length === 0 && json.allArticleIds) {
          // json.allArticleIds contiene solo gli ID validi
          //const allArticlesRemote = this.$root.contents?.articles || {};

          this.articoli = Object.values(allArticlesRemote)
            .filter(a => !a.deleted_at && a.versions && a.versions.length > 0)
            .filter(a => json.allArticleIds.includes(a.id))
            .sort((a, b) => a.id - b.id)
            .map(a => {
              const fullTitle = a.versions[a.versions.length - 1].title;
              return {
                value: a.id,
                label: fullTitle.length > 20 ? fullTitle.slice(0, 20) + '...' : fullTitle,
                fullLabel: fullTitle
              };
            });
        }
        // ...
      } catch (err) {
        console.error("Errore loadQuestions", err);
      } finally {
        // ...
        this.isLoading = false;
      }
    }
    ,
    async loadAllTopics() {
      const response = await this.$root.$api.get('/questions/topics');
      this.allTopics = response.data;
    },
    async loadAllLegislations() {
      //const response = await this.$root.$api.get('/questions/legislations');
      //this.allLegislations = response.data;
      this.allLegislations = Object.values(this.$root.dlgs || {});
    },
    async loadAllRegions() {
      const response = await this.$root.$api.get('/questions/regions');
      this.allRegions = response.data;
    },
    async loadAvailableYears() {
      const response = await this.$root.$api.get('/questions/years');
      this.allYears = response.data;
    },
    handleSort({ field, direction }) {
      this.sortField = field;
      this.sortDirection = direction;
      this.loadQuestions(1);
    },
    applyFilter(filters) {
      this.filterId = filters.id || '';
      this.filterObject = filters.object || '';
      this.filterOrganization = filters.organization || '';
      this.filterText = filters.text || '';
      this.filterRegion = Array.isArray(this.filterRegion) ? this.filterRegion.join(',') : '',
        this.filterYear = Array.isArray(this.filterYear) ? this.filterYear.join(',') : '';

      if (filters.articolo?.length > 0) {
        this.selectedArticles = filters.articolo;
      }

      if (filters.state?.length > 0) {
        this.selectedStates = filters.state;
      }

      this.loadQuestions(1);
      //this.loadQuestions(filters);
    },
    async onLegislationChange(newLegId) {
      this.selectedLegislation = newLegId;
      this.selectedArticles = [];
      if (!newLegId) {
        this.allArticles = [];
        return;
      }

      try {
        const response = await this.$root.$api.get('/articles/bylegislation', {
          params: { legislation_id: newLegId }
        });
        this.allArticles = response.data.map(a => ({
          ...a,
          title: a.versions[a.versions.length - 1]?.title || ''
        }));
      } catch (error) {
        this.showErrorToast('Errore', 'Impossibile caricare articoli per la legislazione selezionata');
      }
    },
    async downloadPdf() {
      this.isDownloading = true;
      try {


        const ids = this.questions.map(q => q.id);

        const params = {
          ids: ids.join(','),
          topics: this.selectedTopics.join(','),
          articles: this.selectedArticles.join(','),
          legislation_id: this.selectedLegislation || '',
          region: Array.isArray(this.filterRegion) ? this.filterRegion.join(',') : '',
          year: Array.isArray(this.filterYear) ? this.filterYear.join(',') : '',
          sortField: this.sortField,
          sortDirection: this.sortDirection,
        };

        const response = await this.$root.$api.get('/questions/pdf/export', {
          params,
          responseType: 'blob'
        });
        /***/
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'quesiti_dettaglio.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();

        /***/
        /*window.open(`/api/questions/pdf/export?${params.toString()}`, '_blank');*/
      } catch (error) {
        this.showErrorToast('Errore', 'Impossibile scaricare il PDF');
      } finally {
        this.isDownloading = false;
      }
    },
    selectSort(option) {
      this.sortField = option.field;
      this.sortDirection = option.direction;
      this.loadQuestions(1);
    },
    /**watch: {
      '$route.query.sent'(newVal) {
        if (newVal === 'true') {
          this.showSentModal = true;
          // Rimuove la query dopo aver mostrato il modal
          this.$router.replace({ query: { ...this.$route.query, sent: undefined } });
        }
      }
    },*/
    watch: {
      '$route.query.sent'(newVal) {
        if (newVal === 'true') {
          this.showSentModal = true;
          // Rimuove la query dopo aver mostrato il modal
          this.$router.replace({ query: { ...this.$route.query, sent: undefined } });
        }
      }
    },
  },
  async mounted() {
    const roles = this.$root?.user?.roles || [];
    this.isGestore = roles.some(role => role.id === 2);
    await this.loadAvailableYears();
    await this.loadAllRegions();
    await this.loadAllTopics();
    await this.loadAllLegislations();
    await this.loadQuestions();
    console.log('Query nel mounted:', this.$route.query);
    if (this.$route.query.inviato === 'true') {
      this.showSentModal = true;
      // Rimuove il parametro dalla URL
      this.$router.replace({ query: { ...this.$route.query, inviato: undefined } });
    }
    const { emit } = useEventEmitter();
    emit('set-navbar-view', 'QuestionsView');

  }
};
</script>
<style scoped>
.question-list {
  padding: 2rem;
}

/* Tabella base */

/* BOOTSTRAP ITALIA TABLE */
.it-table-wrapper table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.it-table-wrapper table thead {
  background-color: #0d6efd !important;
  color: white !important;
}

/* LOADING OVERLAY */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-box {
  text-align: center;
}

/* Spinner dots */
.spinner-container {
  display: flex;
  justify-content: center;
}

.dot {
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: #0d6efd;
  border-radius: 50%;
  animation: bounce 1s infinite ease-in-out;
}

@keyframes bounce {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}

.table th,
.table td {
  vertical-align: middle;
}

.question-list table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  table-layout: fixed;
  width: 100%;
}

.question-list table thead {
  background-color: #0d6efd !important;
  color: white !important;
}

.question-list ::v-deep(table thead th) {
  text-align: center !important;
  vertical-align: middle !important;
}

/* Hover */
.question-list table tbody tr:hover {
  background-color: #f1f5fb;
  transition: background-color 0.2s ease;
}

/* Celle */
.question-list ::v-deep(.table-card table th),
.question-list ::v-deep(.table-card table td) {
  text-align: center;
  padding: 0.75rem 1rem;
}

/* Colonne specifiche 
.question-list ::v-deep(.table-card table th:nth-child(1)) {
  width: 5%;
}
.question-list ::v-deep(.table-card table th:nth-child(2)) {
  width: 10%;
}
.question-list ::v-deep(.table-card table th:nth-child(3)) {
  width: 25%;
}
.question-list ::v-deep(.table-card table th:nth-child(4)) {
  width: 40%;
  text-align: left;
}
.question-list ::v-deep(.table-card table th:nth-child(5)) {
  width: 15%;
}
.question-list ::v-deep(.table-card table th:nth-child(6)) {
  width: 5%;
}
  */

/* Celle centrali truncate */
.question-list ::v-deep(.table-card table td:nth-child(3)) {
  width: 15%;
  max-width: 15%;
  overflow: hidden;
}

.question-list ::v-deep(.table-card table td:nth-child(4)) {
  text-align: left;
}

/* 📏 Imposta proporzioni coerenti per le colonne principali */
.question-list ::v-deep(.modern-table th:nth-child(1)),
.question-list ::v-deep(.modern-table td:nth-child(1)) {
  width: 6%;
}

.question-list ::v-deep(.modern-table th:nth-child(2)),
.question-list ::v-deep(.modern-table td:nth-child(2)) {
  width: 12%;
}

.question-list ::v-deep(.modern-table th:nth-child(3)),
.question-list ::v-deep(.modern-table td:nth-child(3)) {
  width: 20%;
}

.question-list ::v-deep(.modern-table th:nth-child(4)),
.question-list ::v-deep(.modern-table td:nth-child(4)) {
  width: 25%;
}

.question-list ::v-deep(.modern-table th:nth-child(5)),
.question-list ::v-deep(.modern-table td:nth-child(5)) {
  width: 30%;
}

.question-list ::v-deep(.modern-table th:nth-child(6)),
.question-list ::v-deep(.modern-table td:nth-child(6)) {
  width: 7%;
}


.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: #0d6efd;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.15em;
}

.dropdown-menu .dropdown-header.fw-bold {
  font-size: 0.95rem;
}

.dropdown-menu .form-check-label.small,
.dropdown-menu a.dropdown-item.small {
  font-size: 0.875rem;
}

.dropdown-menu .form-check-label,
.dropdown-menu a.dropdown-item {
  font-size: 0.8rem !important;
}

.dropdown-menu {
  top: 167% !important;
  bottom: auto !important;
  transform: none !important;
  z-index: 9999 !important;
  margin-top: 0.25rem;
  left: -12.25rem !important;
}

.dropdown-menu[aria-labelledby="sortDropdown"] {
  min-width: 15.6rem !important;
  max-width: 17.5rem !important;
  padding: 0.75rem !important;
  max-height: 18.8rem !important;
  white-space: nowrap;
}

.dropdown-menu[aria-labelledby="sortDropdown"] a.dropdown-item {
  padding: 0.5rem 1rem !important;
  font-size: 0.875rem;
}

.dropdown-menu[aria-labelledby="sortDropdown"] a.dropdown-item.active {
  background-color: var(--bs-primary) !important;
  color: #fff !important;
}

.dropdown-menu[aria-labelledby="filterDropdown"] {
  min-width: 16.94rem !important;
  max-height: 18.75rem;
  overflow-y: auto;
}


.loading-overlay>* {
  animation: fadeIn 0.2s ease-in-out;
  /* optional fade-in del modal */
}

.loading-text {
  margin-top: 1rem;
  font-weight: bold;
  color: var(--bs-primary);
}

.loading-modal {
  animation: fadeIn 0.2s ease-in-out;
}

.loading-modal .modal-content {
  background: rgba(255, 255, 255, 0.95);
}

.loading-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1050;
}

.form-check-input.radio-look {
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  appearance: none;
  /* rimuove lo stile nativo */
  border: 2px solid #0d6efd;
  position: relative;
  cursor: pointer;
  outline: none;
}

.form-check-input.radio-look:checked::before {
  content: '';
  display: block;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #0d6efd;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-xl {
  max-width: 95% !important;
}

.loading-overlay {
  position: fixed;
  /* Copre tutta la finestra */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-trasparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  /* Deve essere sopra tutto */
  overflow: hidden;
  /* Previene scroll */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.rounded-form {
  border-radius: 1rem;
  overflow: hidden;
  border: 1px solid #ddd;
}

.modal-content {
  border-radius: 1rem !important;
  overflow: hidden;
}
</style>